import axios from "axios";
import { environment } from "../../../environments/environment";


export function createInterchangeability(partId, body) {
  return axios.request({
    method: "PUT",
    url: `${environment.createInterchangeability}?partId=${partId}`, 
    data: body
  })
}

export function postInterchangeability(partId, body) {
  return axios.request({
    method: "POST",
    url: `${environment.createInterchangeability}?partId=${partId}`, 
    data: body
  })
}


export function getInterhcangeabilities(partId) {
  return axios.get(`${environment.getInterchangeabilities}?partId=${partId}&page=0&pageSize=20`)
}

export function targetInterchangeabilities(partId) {
  return axios.get(`${environment.getTargetInterchangeabilities}?partId=${partId}`);
}

export function deleteInterchangeability(itemId){
  return axios.delete(`${environment.deleteInterchangeability}?id=${itemId}`);
}

export function simulateInterchangeability(partId, body){
  return axios.put(`${environment.simulateInterchangeability}?partId=${partId}`, body);
}